import BaseService from "@shared-services/base.service";
import { Dealer, Installer } from "./installers.models";

const useUniApi = true;

class InstallerService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  //Note: Can leave out installer type to get all, including retailers, & then filter

  async getInstallersAsync(country: string, city: string) {
    // NOTE: This is a workaround for bad data in the installers DB for africa
    if (city.includes("Dar es Salaam")) {
      city = "Dar-es- Salaam";
    }

    const path = useUniApi
      ? `InstallersAndDealers/Find?installerType=installer&country=${country}&city=${city}`
      : `GetInstallers?country=${country}&city=${city}`;
    return this._get<Installer[]>(path);
  }

  async getDealerAsync(country: string, city: string) {
    const path = useUniApi
      ? `InstallersAndDealers/Find?installerType=dealer&country=${country}&city=${city}`
      : `GetDealers?country=${country}&city=${city}`;
    return this._get<Installer[]>(path);
  }

  async getCitiesAsync(country: string) {
    const path = `FindInstaller/GetInstallerCityByCountry?country=${country}`;
    return this._get<string[]>(path);
  }
}

export default InstallerService;
